export default __webpack_public_path__ + "static/news1-0cbb4d6210f888cbc6426ed5e1b16b79.jpeg";